import { type ChainMap } from '@chainflip/utils/chainflip';
import useRpcRequest from '@/shared/hooks/useRpcRequest';
import { keys } from '@/shared/utils/objects';

export const useRpcChainflipBlockConfirmations = () =>
  useRpcRequest({
    method: 'cf_environment',
    args: [],
    select: (result) => {
      const confirmationsMap = result.ingress_egress.witness_safety_margins;
      return keys(confirmationsMap).reduce(
        (acc, chain) => {
          acc[chain] = confirmationsMap[chain] ? Number(confirmationsMap[chain]) + 1 : undefined;
          return acc;
        },
        {
          Bitcoin: 3,
        } as ChainMap<number | undefined>,
      );
    },
  });
